// 超简单测试指令 - Vue 2.x 兼容版本
export const simpleTestDirective = {
  bind(el, binding, vnode) {
    console.log('=== SIMPLE TEST DIRECTIVE BIND ===')
    console.log('Element:', el)
    console.log('Binding:', binding)
    console.log('VNode:', vnode)
    
    // 改变元素样式
    el.style.backgroundColor = 'lime'
    el.style.color = 'black'
    el.textContent = '指令工作正常！'
    
    console.log('Element after directive:', {
      backgroundColor: el.style.backgroundColor,
      color: el.style.color,
      textContent: el.textContent
    })
    
    // 添加一个标记类
    el.classList.add('directive-applied')
    console.log('Added directive-applied class')
  },
  
  // Vue 2.x 兼容
  inserted(el, binding, vnode) {
    console.log('=== SIMPLE TEST DIRECTIVE INSERTED ===')
    
    // 使用最强力的样式应用方法
    const originalStyle = el.getAttribute('style') || ''
    
    // 方法1: 直接设置style属性
    el.style.backgroundColor = 'lime'
    el.style.color = 'black'
    
    // 方法2: 使用setProperty设置!important
    el.style.setProperty('background-color', 'lime', 'important')
    el.style.setProperty('color', 'black', 'important')
    
    // 方法3: 通过setAttribute强制设置
    const newStyle = originalStyle + '; background-color: lime !important; color: black !important;'
    el.setAttribute('style', newStyle)
    
    // 方法4: 添加CSS类
    el.classList.add('directive-lime-bg')
    
    // 方法5: 直接操作CSS样式表
    const styleId = 'directive-lime-styles-' + Date.now()
    const styleElement = document.createElement('style')
    styleElement.id = styleId
    styleElement.textContent = `
      .directive-lime-bg-${styleId} {
        background-color: lime !important;
        color: black !important;
      }
    `
    document.head.appendChild(styleElement)
    el.classList.add(`directive-lime-bg-${styleId}`)
    
    console.log('Final style attribute:', el.getAttribute('style'))
    console.log('Final style object:', {
      backgroundColor: el.style.backgroundColor,
      color: el.style.color
    })
    
    // 检查最终应用的样式
    const computedStyle = window.getComputedStyle(el)
    console.log('Computed styles:', {
      backgroundColor: computedStyle.backgroundColor,
      color: computedStyle.color
    })
    
    // 如果仍然没有效果，使用定时器重复应用
    setTimeout(() => {
      el.style.setProperty('background-color', 'lime', 'important')
      el.style.setProperty('color', 'black', 'important')
      console.log('Re-applied styles after timeout')
      
      // 再次检查样式
      const finalComputedStyle = window.getComputedStyle(el)
      console.log('Final computed styles after timeout:', {
        backgroundColor: finalComputedStyle.backgroundColor,
        color: finalComputedStyle.color
      })
      
      // 如果仍然没有效果，尝试其他方法
      if (finalComputedStyle.backgroundColor !== 'rgb(0, 255, 0)') {
        console.log('Styles still not applied, trying alternative method')
        // 使用CSS变量
        el.style.setProperty('--directive-lime-bg', 'lime')
        el.style.setProperty('--directive-lime-color', 'black')
        el.style.background = 'var(--directive-lime-bg)'
        el.style.color = 'var(--directive-lime-color)'
      }
    }, 100)
  },
  
  // Vue 2.x 兼容
  update(el, binding, vnode, oldVnode) {
    console.log('=== SIMPLE TEST DIRECTIVE UPDATE ===',binding)
    // 更新时重新应用样式
    el.style.setProperty('background-color', 'lime', 'important')
    el.style.setProperty('color', 'black', 'important')
  },
  
  // Vue 2.x 兼容
  componentUpdated(el, binding, vnode, oldVnode) {
    console.log('=== SIMPLE TEST DIRECTIVE COMPONENT UPDATED ===')
    // 组件更新后重新应用样式
    el.style.setProperty('background-color', 'lime', 'important')
    el.style.setProperty('color', 'black', 'important')
  },
  
  // Vue 2.x 兼容
  unbind(el, binding, vnode) {
    console.log('=== SIMPLE TEST DIRECTIVE UNBIND ===')
  }
}

// 测试指令 - 验证基本功能 (Vue 2.x 兼容)
export const testDirective = {
  bind(el, binding, vnode) {
    console.log('=== TEST DIRECTIVE BIND ===',binding)
    console.log(vnode)
    console.log('Element:', el)
    console.log('Element tagName:', el.tagName)
    console.log('Element innerHTML:', el.innerHTML)
    
    // 改变元素背景色来验证指令是否工作
    el.style.backgroundColor = 'yellow'
    el.style.border = '3px solid red'
    
    console.log('Element styles after test directive:', {
      backgroundColor: el.style.backgroundColor,
      border: el.style.border
    })
  },
  
  inserted(el, binding, vnode) {
    console.log('=== TEST DIRECTIVE INSERTED ===')
    
    // 使用最强力的样式应用方法
    const originalStyle = el.getAttribute('style') || ''
    
    // 方法1: 直接设置style属性
    el.style.backgroundColor = 'yellow'
    el.style.border = '3px solid red'
    
    // 方法2: 使用setProperty设置!important
    el.style.setProperty('background-color', 'yellow', 'important')
    el.style.setProperty('border', '3px solid red', 'important')
    
    // 方法3: 通过setAttribute强制设置
    const newStyle = originalStyle + '; background-color: yellow !important; border: 3px solid red !important;'
    el.setAttribute('style', newStyle)
    
    // 方法4: 添加CSS类
    el.classList.add('directive-yellow-bg')
    
    // 方法5: 直接操作CSS样式表 - 使用最高优先级选择器
    const styleId = 'directive-styles-' + Date.now()
    const styleElement = document.createElement('style')
    styleElement.id = styleId
    
    // 获取元素的所有属性，包括Vue的scoped属性
    const elementAttributes = Array.from(el.attributes).map(attr => `${attr.name}="${attr.value}"`).join('][')
    const scopedSelector = elementAttributes ? `[${elementAttributes}]` : ''
    
    styleElement.textContent = `
      ${scopedSelector}.directive-yellow-bg-${styleId} {
        background-color: yellow !important;
        border: 3px solid red !important;
      }
      
      /* 使用更高优先级的选择器 */
      ${scopedSelector}.directive-yellow-bg-${styleId}[style*="background"] {
        background-color: yellow !important;
        border: 3px solid red !important;
      }
      
      /* 使用属性选择器的最高优先级 */
      ${scopedSelector}[data-v-*] {
        background-color: yellow !important;
        border: 3px solid red !important;
      }
    `
    
    document.head.appendChild(styleElement)
    el.classList.add(`directive-yellow-bg-${styleId}`)
    
    // 添加data属性来帮助选择器
    el.setAttribute('data-directive-applied', 'true')
    
    console.log('Final style attribute:', el.getAttribute('style'))
    console.log('Final style object:', {
      backgroundColor: el.style.backgroundColor,
      border: el.style.border
    })
    
    // 检查最终应用的样式
    const computedStyle = window.getComputedStyle(el)
    console.log('Computed styles:', {
      backgroundColor: computedStyle.backgroundColor,
      border: computedStyle.border
    })
    
    // 如果仍然没有效果，使用定时器重复应用
    setTimeout(() => {
      el.style.setProperty('background-color', 'yellow', 'important')
      el.style.setProperty('border', '3px solid red', 'important')
      console.log('Re-applied styles after timeout')
      
      // 再次检查样式
      const finalComputedStyle = window.getComputedStyle(el)
      console.log('Final computed styles after timeout:', {
        backgroundColor: finalComputedStyle.backgroundColor,
        border: finalComputedStyle.border
      })
      
      // 如果仍然没有效果，尝试其他方法
      if (finalComputedStyle.backgroundColor !== 'rgb(255, 255, 0)') {
        console.log('Styles still not applied, trying alternative method')
        // 使用CSS变量
        el.style.setProperty('--directive-bg', 'yellow')
        el.style.setProperty('--directive-border', '3px solid red')
        el.style.background = 'var(--directive-bg)'
        el.style.border = 'var(--directive-border)'
        
        // 最后尝试：直接修改CSS规则
        const allStyles = document.styleSheets
        for (let sheet of allStyles) {
          try {
            const rules = sheet.cssRules || sheet.rules
            for (let rule of rules) {
              if (rule.selectorText && rule.selectorText.includes('test-item')) {
                console.log('Found conflicting CSS rule:', rule.selectorText)
                // 尝试覆盖这个规则
                rule.style.setProperty('background-color', 'yellow', 'important')
                rule.style.setProperty('border', '3px solid red', 'important')
              }
            }
          } catch (e) {
            console.log('Cannot access stylesheet:', e)
          }
        }
      }
    }, 100)
  },
  
  // 添加update钩子确保样式持续应用
  update(el, binding, vnode, oldVnode) {
    console.log('=== TEST DIRECTIVE UPDATE ===')
    el.style.backgroundColor = 'yellow'
    el.style.border = '3px solid red'
    el.style.setProperty('background-color', 'yellow', 'important')
    el.style.setProperty('border', '3px solid red', 'important')
  },
  
  // 添加componentUpdated钩子
  componentUpdated(el, binding, vnode, oldVnode) {
    console.log('=== TEST DIRECTIVE COMPONENT UPDATED ===')
    el.style.backgroundColor = 'yellow'
    el.style.border = '3px solid red'
    el.style.setProperty('background-color', 'yellow', 'important')
    el.style.setProperty('border', '3px solid red', 'important')
  }
}

// 动画指令 (Vue 2.x 兼容)
export const animationDirective = {
  bind(el, binding, vnode) {
    console.log('=== Animation directive bind ===')
    console.log('Element:', el)
    console.log('Binding:', binding)
    console.log('Element classes before:', el.className)
    
    // 强制设置初始状态
    el.style.opacity = '1'
    el.style.transform = 'none'
    
    console.log('Element styles after setting:', {
      opacity: el.style.opacity,
      transform: el.style.transform
    })
  },
  
  inserted(el, binding, vnode) {
    console.log('=== Animation directive inserted ===')
    
    // 延迟初始化
    setTimeout(() => {
      console.log('Initializing IntersectionObserver...')
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          console.log('Intersection entry:', entry)
          if (entry.isIntersecting) {
            console.log('Element intersecting, adding animate-in class')
            el.classList.add('animate-in')
            console.log('Element classes after adding animate-in:', el.className)
            observer.unobserve(el)
          }
        })
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      })

      observer.observe(el)
      el._animationObserver = observer
      console.log('Observer created and observing element')
    }, 300)
  },
  
  unbind(el, binding, vnode) {
    console.log('Animation directive unbind for:', el)
    if (el._animationObserver) {
      el._animationObserver.disconnect()
    }
  }
}

// 预定义指令 (Vue 2.x 兼容)
export const fadeInDirective = {
  bind(el, binding, vnode) {
    console.log('=== FadeIn directive bind ===')
    console.log('Element:', el)
    console.log('Adding fade-in class...')
    el.classList.add('fade-in')
    console.log('Element classes after adding fade-in:', el.className)
    animationDirective.bind(el, binding, vnode)
  },
  
  inserted(el, binding, vnode) {
    animationDirective.inserted(el, binding, vnode)
  },
  
  unbind(el, binding, vnode) {
    animationDirective.unbind(el, binding, vnode)
  }
}

export const slideInLeftDirective = {
  bind(el, binding, vnode) {
    console.log('=== SlideInLeft directive bind ===')
    console.log('Element:', el)
    console.log('Adding slide-in-left class...')
    el.classList.add('slide-in-left')
    console.log('Element classes after adding slide-in-left:', el.className)
    animationDirective.bind(el, binding, vnode)
  },
  
  inserted(el, binding, vnode) {
    animationDirective.inserted(el, binding, vnode)
  },
  
  unbind(el, binding, vnode) {
    animationDirective.unbind(el, binding, vnode)
  }
}

export const slideInRightDirective = {
  bind(el, binding, vnode) {
    console.log('=== SlideInRight directive bind ===')
    console.log('Element:', el)
    console.log('Adding slide-in-right class...')
    el.classList.add('slide-in-right')
    console.log('Element classes after adding slide-in-right:', el.className)
    animationDirective.bind(el, binding, vnode)
  },
  
  inserted(el, binding, vnode) {
    animationDirective.inserted(el, binding, vnode)
  },
  
  unbind(el, binding, vnode) {
    animationDirective.unbind(el, binding, vnode)
  }
}

export const slideInUpDirective = {
  bind(el, binding, vnode) {
    console.log('=== SlideInUp directive bind ===')
    el.classList.add('slide-in-up')
    animationDirective.bind(el, binding, vnode)
  },
  
  inserted(el, binding, vnode) {
    animationDirective.inserted(el, binding, vnode)
  },
  
  unbind(el, binding, vnode) {
    animationDirective.unbind(el, binding, vnode)
  }
}

export const scaleInDirective = {
  bind(el, binding, vnode) {
    console.log('=== ScaleIn directive bind ===')
    el.classList.add('scale-in')
    animationDirective.bind(el, binding, vnode)
  },
  
  inserted(el, binding, vnode) {
    animationDirective.inserted(el, binding, vnode)
  },
  
  unbind(el, binding, vnode) {
    animationDirective.unbind(el, binding, vnode)
  }
}

export const rotateInDirective = {
  bind(el, binding, vnode) {
    console.log('=== RotateIn directive bind ===')
    el.classList.add('rotate-in')
    animationDirective.bind(el, binding, vnode)
  },
  
  inserted(el, binding, vnode) {
    animationDirective.inserted(el, binding, vnode)
  },
  
  unbind(el, binding, vnode) {
    animationDirective.unbind(el, binding, vnode)
  }
}

export const bounceInDirective = {
  bind(el, binding, vnode) {
    console.log('=== BounceIn directive bind ===')
    el.classList.add('bounce-in')
    animationDirective.bind(el, binding, vnode)
  },
  
  inserted(el, binding, vnode) {
    animationDirective.inserted(el, binding, vnode)
  },
  
  unbind(el, binding, vnode) {
    animationDirective.unbind(el, binding, vnode)
  }
}

export default animationDirective 